/**
 * Created by yuvashree.m on 17-04-2019.
 */
import { MenuList } from '../models/menu.list';
import { LanguageConstant } from './language.constant';

export class MenuListConstant {
  public static get MENULIST(): any {
    return {
      menu: <MenuList>{
        menuName: 'menu',
        menuLangCode: 'LANG00180',
        menuIconName: 'menu_menu_icon',
        isIconAvailable: true,
        imgPathName: 'menu',
        menuListItems: [
          {
            menuListName: 'newtable',
            menuListLangCode: 'LANG01107',
            menuListIconName: 'icon_menu_lobby_doors@2x',
          },
          {
            menuListName: 'languages',
            menuListLangCode: 'LANG00181',
            menuListIconName: 'menu_languages_brown',
          },
          {
            menuListName: 'settings',
            menuListLangCode: 'LANG00147',
            menuListIconName: 'menu_settings',
          },
          {
            menuListName: 'tutorials',
            menuListLangCode: 'LANG00185',
            menuListIconName: 'menu_tutorials',
          },
          {
            menuListName: 'quickkeys',
            menuListLangCode: 'LANG00184',
            menuListIconName: 'menu_quickkeys',
          },
          {
            menuListName: 'videotutorials',
            menuListLangCode: 'LANG00146',
            menuListIconName: 'menu_videotutorials',
          },
          {
            menuListName: 'premiumpay',
            menuListLangCode: 'LANG00186',
            menuListIconName: 'menu_premiumpays',
          },
          {
            menuListName: 'history',
            menuListLangCode: 'LANG00182',
            menuListIconName: 'menu_history',
          },
          {
            menuListName: 'communityforums',
            menuListLangCode: 'LANG00187',
            menuListIconName: 'menu_community_forum',
          },
          {
            menuListName: 'fixourtranslations',
            menuListLangCode: 'LANG00188',
            menuListIconName: 'menu_fix_translation',
          },
          {
            menuListName: 'helpdesk',
            menuListLangCode: 'LANG00189',
            menuListIconName: 'menu_helpdesk',
          },
          {
            menuListName: 'aboutus',
            menuListLangCode: 'LANG00150',
            menuListIconName: 'menu_aboutus',
          },
          {
            menuListName: 'warnings',
            menuListLangCode: 'LANG01057',
            menuListIconName: 'menu_warnings',
          },
          {
            menuListName: 'logout',
            menuListLangCode: 'LANG00190',
            menuListIconName: 'menu_logout',
          },
        ],
      },
      selecttable: <MenuList>{
        menuName: 'selecttable',
        menuLangCode: 'LANG00160',
        menuIconName: 'menu_menu_icon',
        isIconAvailable: true,
        imgPathName: 'menu',
        menuListItems: [
          {
            menuListName: 'home',
            menuListLangCode: 'LANG01106',
            menuListIconName: 'menu_home',
          },
          {
            menuListName: 'languages',
            menuListLangCode: 'LANG00181',
            menuListIconName: 'menu_languages_brown',
          },
          {
            menuListName: 'settings',
            menuListLangCode: 'LANG00147',
            menuListIconName: 'menu_settings',
          },
          {
            menuListName: 'tutorials',
            menuListLangCode: 'LANG00185',
            menuListIconName: 'menu_tutorials',
          },
          {
            menuListName: 'quickkeys',
            menuListLangCode: 'LANG00184',
            menuListIconName: 'menu_quickkeys',
          },
          {
            menuListName: 'videotutorials',
            menuListLangCode: 'LANG00146',
            menuListIconName: 'menu_videotutorials',
          },
          {
            menuListName: 'premiumpay',
            menuListLangCode: 'LANG00186',
            menuListIconName: 'menu_premiumpays',
          },
          {
            menuListName: 'history',
            menuListLangCode: 'LANG00182',
            menuListIconName: 'menu_history',
          },
          {
            menuListName: 'communityforums',
            menuListLangCode: 'LANG00187',
            menuListIconName: 'menu_community_forum',
          },
          {
            menuListName: 'fixourtranslations',
            menuListLangCode: 'LANG00188',
            menuListIconName: 'menu_fix_translation',
          },
          {
            menuListName: 'helpdesk',
            menuListLangCode: 'LANG00189',
            menuListIconName: 'menu_helpdesk',
          },
          {
            menuListName: 'aboutus',
            menuListLangCode: 'LANG00150',
            menuListIconName: 'menu_aboutus',
          },
          {
            menuListName: 'warnings',
            menuListLangCode: 'LANG01057',
            menuListIconName: 'menu_warnings',
          },
          {
            menuListName: 'logout',
            menuListLangCode: 'LANG00190',
            menuListIconName: 'menu_logout',
          },
        ],
      },
      newtable: <MenuList>{
        menuName: 'newtable',
        menuLangCode: 'LANG00160',
        menuIconName: 'device',
        isIconAvailable: true,
        imgPathName: 'flags',
        menuListItems: [
          {
            menuListName: 'livedealer',
            menuListLangCode: 'LANG00860',
            menuListIconName: 'livedealer_brown',
          },
          {
            menuListName: 'livecasino',
            menuListLangCode: 'LANG00861',
            menuListIconName: 'livecasino_brown',
          },
          {
            menuListName: 'private',
            menuListLangCode: 'LANG00862',
            menuListIconName: 'private_brown',
          },
        ],
      },
      languages: <MenuList>{
        menuName: 'languages',
        menuLangCode: 'LANG00181',
        menuIconName: 'menu_languages_icon',
        isIconAvailable: true,
        imgPathName: 'flags',
        menuListItems: [
          {
            menuListName: 'arabic',
            menuListCode: 'ar', // LanguageConstant.ARMENIAN
            menuListLangCode: 'LANG00997', // Given for english, Arabic --- عربى //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00954', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Adobe-Arabic',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: true,
            menuListIconName: 'ar',
            fontSizeForce: '8.2vw',
          },
          {
            menuListName: 'armenian',
            menuListCode: 'hy',
            menuListLangCode: 'LANG00998', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00955', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVuSans-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'hy',
            fontFamilyForce: 'Helvetica, Arial, sans-serif',
          },
          {
            menuListName: 'bulgarian',
            menuListCode: 'bg',
            menuListLangCode: 'LANG00999', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00956', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'bg',
          },
          {
            menuListName: 'cambodian',
            menuListCode: 'kh',
            menuListLangCode: 'LANG01000', // Khmer -- ភាសាខ្មែរ //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00957', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Chantrea-UI',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'kh',
          },
          {
            menuListName: 'chinese_simplified',
            menuListCode: 'zh-Hans',
            menuListLangCode: 'LANG01001', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00958', // langcode for specific languages in english
            menuListSubLangFontFamily: 'HiraginoSansGBW3',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'zh-Hans',
          },
          {
            menuListName: 'chinese_traditional',
            menuListCode: 'zh-Hant',
            menuListLangCode: 'LANG01002', // Given for Chinese Simplified , Chinese Traditional ---  中國傳統的 -- LANG00137
            menuListSubLangCode: 'LANG00959', // langcode for specific languages in english
            menuListSubLangFontFamily: 'HiraginoSansGBW3',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'zh-Hant',
          },
          {
            menuListName: 'czech',
            menuListCode: 'cs',
            menuListLangCode: 'LANG01003', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00960', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVuSans-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'cs',
          },
          {
            menuListName: 'danish',
            menuListCode: 'da',
            menuListLangCode: 'LANG01004', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00961', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'da',
          },
          {
            menuListName: 'dutch',
            menuListCode: 'nl',
            menuListLangCode: 'LANG01005', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00962', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'nl',
          },
          {
            menuListName: 'english',
            menuListCode: 'en',
            menuListLangCode: 'LANG01006', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00963', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'en',
          },
          {
            menuListName: 'estonian',
            menuListCode: 'ee',
            menuListLangCode: 'LANG01007', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00964', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ee',
          },
          {
            menuListName: 'filipino',
            menuListCode: 'ph',
            menuListLangCode: 'LANG01008', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00965', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ph',
          },
          {
            menuListName: 'finnish',
            menuListCode: 'fi',
            menuListLangCode: 'LANG01009', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00966', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'fi',
          },
          {
            menuListName: 'french',
            menuListCode: 'fr',
            menuListLangCode: 'LANG01010', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00967', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'fr',
          },
          {
            menuListName: 'georgian',
            menuListCode: 'ge',
            menuListLangCode: 'LANG01011', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00968', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVu-Sans',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ge',
          },
          {
            menuListName: 'german',
            menuListCode: 'de',
            menuListLangCode: 'LANG01012', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00969', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'de',
          },
          {
            menuListName: 'greek',
            menuListCode: 'gr',
            menuListLangCode: 'LANG01013', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00970', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'gr',
          },
          {
            menuListName: 'hebrew',
            menuListCode: 'he',
            menuListLangCode: 'LANG01014', // given for english, Hebrew -- עברית //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00971', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Adobe-Hebrew',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: true,
            menuListIconName: 'he',
            fontSizeForce: '7vw',
          },
          {
            menuListName: 'hindi',
            menuListCode: 'hi-IN',
            menuListLangCode: 'LANG01015', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00972', // langcode for specific languages in english
            menuListSubLangFontFamily: 'AdobeDevanagari-Regular',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'hi-IN',
            fontSizeForce: '6vw',
          },
          {
            menuListName: 'hungarian',
            menuListCode: 'hu',
            menuListLangCode: 'LANG01016', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00973', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'hu',
          },
          {
            menuListName: 'indonesian',
            menuListCode: 'id',
            menuListLangCode: 'LANG01017', // Indonesian -- bahasa Indonesia //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00974', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'id',
          },
          {
            menuListName: 'italian',
            menuListCode: 'it',
            menuListLangCode: 'LANG01018', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00975', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'it',
          },
          {
            menuListName: 'japanese',
            menuListCode: 'ja',
            menuListLangCode: 'LANG01019', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00976', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Adobe 고딕 Std',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ja',
          },
          {
            menuListName: 'korean',
            menuListCode: 'ko',
            menuListLangCode: 'LANG01020', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00977', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Adobe 고딕 Std',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ko',
          },
          {
            menuListName: 'latvian',
            menuListCode: 'lv',
            menuListLangCode: 'LANG01021', // Latvian -- Latviešu valoda //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00978', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'lv',
          },
          {
            menuListName: 'Lithuanian',
            menuListCode: 'lt',
            menuListLangCode: 'LANG01022', // Latvian -- Latviešu valoda //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00979', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'lt',
          },
          {
            menuListName: 'malay',
            menuListCode: 'my',
            menuListLangCode: 'LANG01023', // Malay -- Melayu //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00980', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'my',
          },
          {
            menuListName: 'maltese',
            menuListCode: 'mt',
            menuListLangCode: 'LANG01024', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00981', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'mt',
          },
          {
            menuListName: 'norwegian',
            menuListCode: 'nb',
            menuListLangCode: 'LANG01025', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00982', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'nb',
          },
          {
            menuListName: 'polish',
            menuListCode: 'pl',
            menuListLangCode: 'LANG01026', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00983', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVuSans-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'pl',
          },
          {
            menuListName: 'portuguese',
            menuListCode: 'pt-BR',
            menuListLangCode: 'LANG01027', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00984', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'pt-BR',
          },
          {
            menuListName: 'romanian',
            menuListCode: 'ro',
            menuListLangCode: 'LANG01028', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00985', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ro',
          },
          {
            menuListName: 'russian',
            menuListCode: 'ru',
            menuListLangCode: 'LANG01029', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00986', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVu-Sans',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ru',
          },
          {
            menuListName: 'serbian',
            menuListCode: 'sr-RS',
            menuListLangCode: 'LANG01030', // no correct translation //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00987', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'sr-RS',
          },
          {
            menuListName: 'slovakian',
            menuListCode: 'sk',
            menuListLangCode: 'LANG01031', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00988', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'sk',
          },
          {
            menuListName: 'slovenian',
            menuListCode: 'si',
            menuListLangCode: 'LANG01032', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00989', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'si',
          },
          {
            menuListName: 'spanish',
            menuListCode: 'es',
            menuListLangCode: 'LANG01033', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00990', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'es',
          },
          {
            menuListName: 'swedish',
            menuListCode: 'sv',
            menuListLangCode: 'LANG01034', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00991', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'sv',
          },
          {
            menuListName: 'tamil',
            menuListCode: 'ta-IN',
            menuListLangCode: 'LANG01035', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00992', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Verdana-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ta-IN',
          },
          {
            menuListName: 'thai',
            menuListCode: 'th',
            menuListLangCode: 'LANG01036', // no correct translation //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00993', // langcode for specific languages in english
            menuListSubLangFontFamily: 'Loma',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'th',
          },
          {
            menuListName: 'turkish',
            menuListCode: 'tr',
            menuListLangCode: 'LANG01037', // Turkish --- Türkçe //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00994', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVu-Sans',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'tr',
          },
          {
            menuListName: 'ukrainian',
            menuListCode: 'ua',
            menuListLangCode: 'LANG01038', // langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00995', // langcode for specific languages in english
            menuListSubLangFontFamily: 'MyriadPro-Bold',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'ua',
          },
          {
            menuListName: 'vietnamese',
            menuListCode: 'vi',
            menuListLangCode: 'LANG01039', // Vietnamese -- Tiếng Việt  //langcode for specific languages -- LANG00137
            menuListSubLangCode: 'LANG00996', // langcode for specific languages in english
            menuListSubLangFontFamily: 'DejaVu-Sans',
            menuListSubLangFontWeight: 700,
            isDisplaySubTextLeft: false,
            menuListIconName: 'vi',
          },
        ],
      },
      settings: <MenuList>{
        menuName: 'settings',
        menuLangCode: 'LANG00147',
        menuIconName: 'settings_icon',
        isIconAvailable: true,
        imgPathName: 'flags',
      },
      tutorials: <MenuList>{
        menuName: 'tutorials',
        menuLangCode: 'LANG00185',
        menuIconName: 'Tutorials@2x-8',
        isIconAvailable: false,
        imgPathName: 'menu',
        menuListItems: [
          {
            menuListName: 'fullcolorcards',
            menuListLangCode: 'LANG00145',
            menuTutorialsId: 1,
          },
          {
            menuListName: 'plusminusscores',
            menuListLangCode: 'LANG00728',
            menuTutorialsId: 2,
          },
          {
            menuListName: 'gameaction',
            menuListLangCode: 'LANG00731',
            menuTutorialsId: 3,
          },
          {
            menuListName: 'gamerules',
            menuListLangCode: 'LANG00732',
            menuTutorialsId: 4,
          },
          {
            menuListName: 'soft17',
            menuListLangCode: 'LANG00155',
            menuTutorialsId: 5,
          },
          {
            menuListName: 'startagame',
            menuListLangCode: 'LANG00735',
            menuTutorialsId: 6,
          },
          {
            menuListName: 'the4naturals',
            menuListLangCode: 'LANG00736',
            menuTutorialsId: 7,
          },
          {
            menuListName: 'supernatural',
            menuListLangCode: 'LANG00009',
            menuTutorialsId: 8,
          },
          {
            menuListName: 'natural21',
            menuListLangCode: 'LANG00011',
            menuTutorialsId: 9,
          },
          {
            menuListName: 'doublenatural',
            menuListLangCode: 'LANG00010',
            menuTutorialsId: 10,
          },
          {
            menuListName: 'naturalzero',
            menuListLangCode: 'LANG00008',
            menuTutorialsId: 11,
          },
          {
            menuListName: 'bustrules',
            menuListLangCode: 'LANG00729',
            menuTutorialsId: 12,
          },
          {
            menuListName: 'splitpairs',
            menuListLangCode: 'LANG00734',
            menuTutorialsId: 13,
          },
          {
            menuListName: 'impossiblesplits',
            menuListLangCode: 'LANG00733',
            menuTutorialsId: 14,
          },
          {
            menuListName: 'doubledown',
            menuListLangCode: 'LANG00773',
            menuTutorialsId: 15,
          },
          {
            menuListName: 'colorcardinsurance',
            menuListLangCode: 'LANG00768',
            menuTutorialsId: 16,
          },
          {
            menuListName: 'whitecardinsurance',
            menuListLangCode: 'LANG00806',
            menuTutorialsId: 17,
          },
          {
            menuListName: 'russianroulette',
            menuListLangCode: 'LANG00479',
            menuTutorialsId: 18,
          },
          {
            menuListName: 'handranks',
            menuListLangCode: 'LANG00411',
            menuTutorialsId: 19,
          },
          {
            menuListName: 'handrankdetails',
            menuListLangCode: 'LANG00827',
            menuTutorialsId: 20,
          },
          {
            menuListName: 'premiumpays',
            menuListLangCode: 'LANG00186',
            menuTutorialsId: 21,
          },
        ],
      },
      handranks: <MenuList>{
        menuName: 'handranks',
        menuLangCode: 'LANG00411',
        menuIconName: 'handranks_icon',
        isIconAvailable: false,
        imgPathName: 'menu',
      },
      handrankdetails: <MenuList>{
        menuName: 'handrankdetails',
        menuLangCode: 'LANG00614',
        menuIconName: 'decks_icon',
        isIconAvailable: false,
        imgPathName: 'menu',
      },
      handrankdealdrawdetails: <MenuList>{
        menuName: 'handrankdealdrawdetails',
        menuLangCode: 'LANG00827',
        menuIconName: 'handranks_icon',
        isIconAvailable: false,
        imgPathName: 'menu',
      },
      premiumpay: <MenuList>{
        menuName: 'premiumpay',
        menuLangCode: 'LANG00186',
        menuIconName: 'menu_premiumpays_white',
        isIconAvailable: true,
        imgPathName: 'menu',
      },
      comingsoon: <MenuList>{
        menuName: 'comingsoon',
        menuLangCode: 'LANG00198',
        menuIconName: 'menu_comingsoon_icon',
        isIconAvailable: true,
        imgPathName: '',
        menuListItems: [
          {
            menuListName: 'coming_soon',
            menuListLangCode: 'LANG00197',
            menuListSubLangCode: 'LANG00198',
            menuListIconName: 'coming_soon_logo',
          },
        ],
      },
      historysummary: <MenuList>{
        menuName: 'historysummary',
        menuLangCode: 'LANG00256',
        menuIconName: 'key',
        imgPathName: 'historysummary',
        menuListItems: [
          {
            menuListName: 'SuperNatural',
            menuListLangCode: 'LANG00009',
            menuListIconName: 'supernatural_icon_mobile',
            tutorialIndex: 8,
          },
          {
            menuListName: 'Natural21',
            menuListLangCode: 'LANG00011',
            menuListIconName: 'natural21_icon_mobile',
            tutorialIndex: 9,
          },
          {
            menuListName: 'DoubleNatural',
            menuListLangCode: 'LANG00010',
            menuListIconName: 'doublenatural_icon_mobile',
            tutorialIndex: 10,
          },
          {
            menuListName: 'NaturalZero',
            menuListLangCode: 'LANG00008',
            menuListIconName: 'naturezero_icon_mobile',
            tutorialIndex: 11,
          },
          {
            menuListName: 'Draw21',
            menuListLangCode: 'LANG00012',
            menuListIconName: 'draw21_icon_mobile',
            tutorialIndex: 11,
          },
          {
            menuListName: 'DrawZero',
            menuListLangCode: 'LANG00013',
            menuListIconName: 'drawzero_icon_mobile',
            tutorialIndex: 2,
          },
          {
            menuListName: 'BUST',
            menuListLangCode: 'LANG00016',
            menuListIconName: 'bust_icon_mobile',
            tutorialIndex: 12,
          },
          {
            menuListName: 'SOFT17',
            menuListLangCode: 'LANG00258',
            menuListIconName: 'soft[17]_icon_mobile',
            tutorialIndex: 5,
          },
          {
            menuListName: 'GameDetails',
            menuListLangCode: 'LANG00216',
            menuListIconName: 'gamedetails_icon_mobile',
          },
          {
            menuListName: 'InsuranceOffered',
            menuListLangCode: 'LANG00257',
            menuListIconName: 'insuranceoffer_icon_mobile',
            tutorialIndex: 16,
          },
        ],
      },
    };
  }
}
